/* Product gallery: swipe left/right on phones. It only drives the existing arrow buttons,
   so arrows, image order and the slide animation stay exactly as they were. */
(() => {
  const psl = document.querySelector('[data-psl]');
  if (!psl) return;
  const track = psl.querySelector('[data-track]'), prev = psl.querySelector('[data-prev]'), next = psl.querySelector('[data-next]');
  const n = track ? track.children.length : 0;
  if (n < 2 || !prev || !next) return;
  const phone = window.matchMedia('(max-width: 749px)');
  const mode = () => { psl.style.touchAction = phone.matches ? 'pan-y pinch-zoom' : ''; };
  mode(); if (phone.addEventListener) phone.addEventListener('change', mode);
  const current = () => { const m = /translateX\(-?([\d.]+)%\)/.exec(track.style.transform); return m ? Math.round(m[1] / 100) : 0; };
  let sx = 0, sy = 0, dx = 0, t0 = 0, i = 0, axis = '';
  psl.addEventListener('touchstart', (e) => {
    axis = phone.matches && e.touches.length === 1 ? '' : 'off';
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; t0 = Date.now();
  }, { passive: true });
  psl.addEventListener('touchmove', (e) => {
    if (axis === 'off' || axis === 'y') return;
    if (e.touches.length > 1) { axis = 'off'; return; }
    const mx = e.touches[0].clientX - sx, my = e.touches[0].clientY - sy;
    if (!axis) {
      if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
      axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
      if (axis === 'y') return;
      i = current(); track.style.transition = 'none';
    }
    dx = (i === 0 && mx > 0) || (i === n - 1 && mx < 0) ? mx / 3 : mx;
    track.style.transform = 'translateX(calc(-' + (i * 100) + '% + ' + dx + 'px))';
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
  const end = () => {
    const was = axis; axis = '';
    if (was !== 'x') return;
    track.style.transition = '';
    const go = Math.abs(dx) > psl.offsetWidth * 0.18 || (Math.abs(dx) > 30 && Date.now() - t0 < 300);
    if (go && dx < 0 && i < n - 1) next.click();
    else if (go && dx > 0 && i > 0) prev.click();
    else track.style.transform = 'translateX(-' + (i * 100) + '%)';
  };
  psl.addEventListener('touchend', end);
  psl.addEventListener('touchcancel', end);
})();
